import { combineReducers } from 'redux'

import basic from './get/basic'
import full from './get/full'

export default combineReducers({
  basic,
  full
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/locations/get.js